import {computed, signal} from '@angular/core';

export const triggeredButton$ = signal(null);
export const loading$ = signal(false);

export function loading(_target: any, _propertyKey: string, descriptor: PropertyDescriptor): PropertyDescriptor {
  const originalMethod = descriptor.value;

  async function replacementMethod(this: any, ...args: any[]) {
    try {
      loading$.set(true);
      return await originalMethod.call(this, ...args)
    } finally {
      loading$.set(false);
    }
  }

  descriptor.value = replacementMethod;
  return descriptor;
}

export const btnLoading$ = computed(() => triggeredButton$() !== null);

/*
export const uiState$ = signal({
  menuCollapsed: false,
})
export const updateUiState = (key: string, value: any) => {
  uiState$.update(state => ({
    ...state, [key]: value
  }))
}
*/
export const title$ = signal<string>('Welcome');
export const activeUrl$ = signal<string>('/');
export const breakpoint$ = signal<string>('');
